import PropTypes from 'prop-types';
import React from 'react';
import TutorToast from '../TutorToast/TutorToast';
import useChatTriggerButton from './useChatTriggerButton';
import './ChatTriggerButton.scss';

function noop() {}

/**
 * ChatbotButton component that serves as a floating button to trigger the chatbot
 */
function ChatTriggerButton({ canShowFirstUseNotice = false, onClick, onFirstUseNoticeDismiss = noop }) {
  const { ariaLabel, buttonRef, className, firstUseNotice, onFirstUseNoticeClose } = useChatTriggerButton({
    canShowFirstUseNotice,
    onFirstUseNoticeDismiss,
  });

  return (
    <>
      {firstUseNotice && (
        <div className="chatbot-button-toast">
          <TutorToast closeLabel={firstUseNotice.closeLabel} onClose={onFirstUseNoticeClose} onTimeout={onFirstUseNoticeDismiss} title={firstUseNotice.title}>
            {firstUseNotice.body}
          </TutorToast>
        </div>
      )}
      <button
        ref={buttonRef}
        type="button"
        className={className}
        onClick={onClick}
        aria-label={ariaLabel}
        style={{ border: 0, background: 'transparent', cursor: 'pointer' }}
      >
        <div className="chatbot-button__image" />
      </button>
    </>
  );
}

ChatTriggerButton.propTypes = {
  /** The widget turns it off once the student closes the toast and while the chat is open. */
  canShowFirstUseNotice: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onFirstUseNoticeDismiss: PropTypes.func,
};

// Use React.memo to prevent unnecessary re-renders
export default React.memo(ChatTriggerButton);
